<template>
  <v-app id="root">
    <!-- <v-app-bar app flat color="white" height="auto" class="py-2" ref="appbar"> -->
    <v-app-bar app flat color="white" height="auto" class="py-2 elevation-1" ref="appbar">
      <!-- <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="vermenu"></v-app-bar-nav-icon> -->
      <!--AQUI EMPIEZA MODIFICACION PARA REPONSIVIDAD-->
      <v-container fluid class="pa-0 py-3">
        <div class="page-boundary">
          <v-row align="center" justify="space-between" class="flex-wrap">
            <v-col cols="12" sm="12" md="12" class="d-flex flex-column">
              <v-menu offset-y bottom :close-on-content-click="false" tile>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on" class="company-activator">
                    <span class="company-title axi-bold">
                      {{ getCompanyName(selectedCompany) || 'Elegir sucursal' }}
                    </span>
                    <v-icon size="18">mdi-chevron-down</v-icon>
                  </div>
                </template>
                <v-sheet elevation="0" tile>
                  <!-- Lista scrolleable -->
                  <v-list
                    dense
                    tile
                    style="max-height: 300px; overflow-y: auto; border-radius: 3px !important; font-family: 'Axiforma'"
                    class="list-design"
                  >
                    <v-list-item
                      v-for="company in filteredCompanies"
                      :key="company.id"
                      @click="selectCompany(company.id)"
                      style="border-radius: 0 !important"
                    >
                      <v-list-item-title>{{ company.nombre }}</v-list-item-title>
                      <v-spacer />
                      <v-icon v-if="selectedCompany === company.id" size="16">mdi-check</v-icon>
                    </v-list-item>
                  </v-list>
                </v-sheet>
              </v-menu>

              <!--span class="text-h5 font-weight-bold">SinCarbono</span-->
              <span class="axi-regular text-caption text-light grey--text company-subtitle mt-2">Dashboard de Huella de Carbono</span>
            </v-col>
          </v-row>
        </div>
      </v-container>
      <!--v-toolbar-title class="d-none d-md-flex">
        {{ name }}
      </v-toolbar-title-->
      <v-col cols="12" md="7" class="d-flex justify-end align-center flex-wrap gap-1">
        <!--v-select
              v-if="companies.length"
              v-model="selectedCompany"
              :items="companies"
              item-value="id"
              item-text="nombre"              
              outlined
              dense
              small
              prepend-inner-icon="mdi-factory"
              class="mx-1 v-step-0"
              light
              hide-details
              style="max-width: 300px"
              color="#6366F1"
            >
            </v-select-->
        <v-col cols="12" class="d-flex justify-end topbar-buttons-container pr-0">
          <div class="header-actions d-flex align-center flex-wrap">
            <v-autocomplete
              id="quitarborde no-borders"
              class="outlined-like-button axi-regular"
              color="#6366F1"
              ref="locationSelect"
              :search-input.sync="displayText"
              no-filter
              :items="filteredItems"
              item-text="name"
              item-value="id"
              outlined
              dense
              hide-details
              clearable
              readonly
              placeholder="Filtrar por ubicaciones"
              :menu-props="{ contentClass: 'location-menu', closeOnContentClick: false, maxHeight: 360, offsetY: true }"
              style="max-width: 250px; color: #6366f1"
              @click="openLocations"
              @click:clear="clearLocations"
              @blur="onCancel"
              @update:search-input="onSearchInput"
            >
              <!-- Encabezado + buscador + seleccionar todo -->
              <template v-slot:prepend-item>
                <div class="px-4 py-3">
                  <div class="d-flex align-center mb-2">
                    <div class="subtitle-2 font-weight-medium">Filtrar por ubicaciones</div>
                    <span class="ml-auto caption grey--text">{{ itemsB.length }} disponibles</span>
                  </div>

                  <v-text-field
                    v-model="search"
                    dense
                    class="rounded outlined-like-button mb-3 axiforma-search"
                    outlined
                    hide-details
                    placeholder="Buscar por nombre..."
                    prepend-inner-icon="mdi-magnify"
                  />

                  <div class="d-flex align-center">
                    <v-checkbox v-model="selectAll" hide-details class="ma-0 pa-0 mr-2" />
                    <div class="subtitle-2">Seleccionar todo</div>
                    <div class="ml-auto caption grey--text">{{ tempSelected.length }} de {{ filteredItems.length }}</div>
                  </div>
                </div>
                <v-divider />
              </template>

              <!-- Ítems con checkbox -->
              <template v-slot:item="{ item }">
                <v-list-item @click.stop="toggle(item.id)">
                  <v-list-item-action>
                    <v-checkbox :input-value="tempSelected.includes(item.id)" @change.stop="toggle(item.id)" hide-details class="ma-0 pa-0" />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.name" />
                  </v-list-item-content>
                </v-list-item>
              </template>

              <template v-slot:append-item>
                <v-divider />
                <div class="d-flex justify-end px-4 py-3 actions-footer">
                  <v-btn text small class="mr-2" @click="onCancel">Cancelar</v-btn>
                  <v-btn color="#6366F1" tile outlined small @click="onApply"> <v-icon left small>mdi-check</v-icon>Aplicar </v-btn>
                </div>
              </template>

              <!-- Acciones
              <template v-slot:append-item>
                <v-divider />
                <div class="d-flex justify-end px-4 py-3">
                  <v-btn text small class="mr-2" @click="onCancel">Cancelar</v-btn>
                  <v-btn small class="apply-gradient white--text" @click="onApply"> <v-icon left small>mdi-check</v-icon>Aplicar </v-btn>
                </div>
              </template> -->
            </v-autocomplete>

            <v-menu v-model="monthMenu" offset-y bottom :close-on-content-click="false" max-width="300" content-class="menu-square">
              <template v-slot:activator="{ on, attrs }">
                <v-btn outlined tile color="#6366F1" class="text-none text-capitalize axi-regular topbar-button" v-bind="attrs" v-on="on">
                  {{ formattedMonth }}
                  <v-icon right size="18" class="ml-6">mdi-calendar</v-icon>
                </v-btn>
              </template>

              <v-date-picker v-model="selectedMonth" type="month" color="#6366F1" @input="onMonthChanged" />
            </v-menu>

            <v-btn outlined tile color="#6366F1" v-if="!isPublic()" :disabled="report" @click="getReportGeneral()" class="topbar-button">
              <v-icon size="20">mdi-download</v-icon>
            </v-btn>
            <v-btn
              outlined
              tile
              color="#6366F1"
              class="text-none axi-regular topbar-button"
              v-if="!isPublic() && isValidUrl()"
              :disabled="report"
              @click="getHomeReportExcel()"
            >
              <v-icon size="20">mdi-file-excel-box</v-icon>
            </v-btn>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn outlined tile color="#6366F1" v-bind="attrs" v-on="on" class="topbar-button"> MX </v-btn>
              </template>
              <v-list>
                <v-list-item>
                  <v-list-item-action> MX </v-list-item-action>
                  <v-list-item-title class="mr-4">Español</v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-action> EU </v-list-item-action>
                  <v-list-item-title>English</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-btn tile text color="#6366F1" class="text-none axi-regular" style="white-space: nowrap" @click="analyticsDrawer = true">
              Abrir analíticas
              <v-icon right size="18">mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-col>

      <!--
      <v-spacer></v-spacer>
      <v-btn
        v-if="isPublic()"
        small
        rounded
        color="secondary"
        class="text-normal black--text mx-1 d-none d-md-flex"
        :href="links.calendly"
        target="_blank"
      >
        Entrevista
      </v-btn>
      <v-btn v-if="!isPublic()" @click="tour()" small rounded color="secondary" class="text-normal black--text mx-1 d-none d-md-flex">
        Ayuda
      </v-btn>
      <v-menu bottom offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" @click.stop="drawerRight = !drawerRight" text rounded class="text-normal mx-1 d-none d-md-flex">
            <v-badge :value="no_leidos.length" :content="no_leidos.length" color="red" overlap>
              <v-icon>mdi-bell</v-icon>
            </v-badge>
          </v-btn>
        </template>
      </v-menu>
      
      <v-toolbar-title class="d-none d-md-flex mx-2">
                {{ name }}>
      </v-toolbar-title>
      <v-menu bottom offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="text-normal mx-1 d-none d-sm-flex" v-bind="attrs" v-on="on" text>
            <v-icon>mdi-account</v-icon>
          </v-btn>
        </template>
        <v-list style="width: 200px">
          <v-list-item>
            <v-btn @click.native="profile()" class="text-normal" style="width: 100%">
              <v-list-item-title>Perfil</v-list-item-title>
              <v-icon>mdi-account-circle</v-icon>
            </v-btn>
          </v-list-item>
          <v-list-item>
            <v-btn @click.native="logout()" color="secondary" class="text-normal black--text" style="width: 100%">
              <v-list-item-title>Salir</v-list-item-title>
              <v-icon>mdi-logout</v-icon>
            </v-btn>
          </v-list-item>
        </v-list>
      </v-menu>
      -->
    </v-app-bar>

    <v-navigation-drawer style="background: #f8f8ff" app clipped v-model="drawer" class="app-sidemenu drawer-no-border" width="270">
      <v-sheet tile elevation="0" color="#F8F8FF" class="px-6 pt-12 pb-12">
        <v-img :src="logo" contain class="mb-4" />
      </v-sheet>
      <!--
      <v-list-item>
        <v-list-item-content class="text-center">
          <v-list-item-title class="title">
            <v-container>
              
            </v-container>
          </v-list-item-title>
          <v-list-item-subtitle color="primary">
            <v-chip class="ma-2 black--text" color="secondary" small> v{{ version }} </v-chip>
          </v-list-item-subtitle>
          <v-list-item-subtitle color="primary"> </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      -->
      <!--v-if="!isPublic()"-->
      <v-list-item style="background: #f8f8ff">
        <v-list-item-content class="text-left">
          <v-list-item-title class="axi-regular" style="font-size: 16px !important; font-weight: 400 !important"> Menú </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item v-show="false">
        <v-list-item-content class="text-center">
          <v-list-item-title color="primary">
            <p style="font-weight: bold">Objetivo</p>
            <p>
              {{ objective }}
            </p>
          </v-list-item-title>
          <v-list-item-subtitle color="primary">
            <!--            <v-select ref="objectiveSelect" class="ma-2 black&#45;&#45;text objetiveselected" v-if="objective === null" color="secondary" :items="objectives" v-model="objective" @change="objectiveCheck()" small label="Establecer objetivo">-->
            <v-select
              ref="objectiveSelect"
              class="ma-2 black--text objetiveselected"
              color="secondary"
              :items="objectives"
              v-model="objective"
              @change="objectiveCheck()"
              small
              label="Establecer objetivo"
            >
            </v-select>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list dense nav class="side-nav">
        <template v-for="item in items">
          <v-list-item
            v-if="item.public || (!item.public && !isPublic())"
            :key="item.title"
            :to="item.path"
            link
            exact
            exact-active-class="menu-active"
            class="px-5"
          >
            <v-list-item-icon>
              <v-icon :color="$route.path === item.path ? '#6366F1' : undefined">
                {{ item.icon }}
              </v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>

      <template v-slot:append>
        <div class="pa-2">
          <v-btn block text small elevation="0" color="primary" class="text-normal" :loading="loading" @click.native="logout()">
            Salir
            <v-icon right dark>mdi-logout</v-icon>
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <v-navigation-drawer app dark color="primary" right v-model="drawerRight" class="app-sidemenu" temporary width="370">
      <v-list-item>
        <v-list-item-content class="text-center">
          <v-list-item-title class="title">
            <v-container> Notificaciones </v-container>
          </v-list-item-title>
          <v-btn
            v-if="!isPublic() && no_leidos.length != 0"
            @click="updateAllNotifications()"
            small
            rounded
            color="secondary"
            class="text-normal black--text mx-1 d-none d-md-flex"
          >
            Marcar todas como leidas.
          </v-btn>
        </v-list-item-content>
      </v-list-item>
      <v-tabs v-model="tab" background-color="indigo" centered dark fixed-tabs>
        <v-tabs-slider color="secondary"></v-tabs-slider>
        <v-tab href="#tab-1"> No leídos </v-tab>
        <v-tab href="#tab-2"> Leidos </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="i in 2" :key="i" :value="'tab-' + i">
          <v-list two-line v-if="i == 1 && no_leidos.length">
            <v-list-item-group v-model="selectedUnread" active-class="blue--text" multiple>
              <template v-for="(item, index) in no_leidos">
                <v-list-item :key="index" @click="showNotification(item)">
                  <template v-slot:default="{ active }">
                    <v-list-item-content>
                      <v-list-item-title v-text="item.titulo"></v-list-item-title>
                      <v-list-item-subtitle v-text="item.subtitulo"></v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-list-item-action-text v-text="item.fecha"></v-list-item-action-text>
                      <v-icon v-if="!active" color="grey lighten-1"> mdi-check-all </v-icon>
                      <v-icon v-else color="yellow darken-3"> mdi-check-all </v-icon>
                    </v-list-item-action>
                  </template>
                </v-list-item>
                <v-divider color="black" v-if="index < no_leidos.length - 1" :key="'div-' + index"></v-divider>
              </template>
            </v-list-item-group>
          </v-list>
          <v-list two-line v-if="i == 2 && leidos.length">
            <v-list-item-group v-model="selectedRead" active-class="blue--text" multiple>
              <template v-for="(item, index) in leidos">
                <v-list-item :key="index" @click="dialogs.notificationRead = true">
                  <template>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.titulo"></v-list-item-title>
                      <v-list-item-subtitle v-text="item.subtitulo"></v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-list-item-action-text v-text="item.fecha"></v-list-item-action-text>
                    </v-list-item-action>
                  </template>
                </v-list-item>
                <v-divider color="black" v-if="index < leidos.length - 1" :key="'div-' + index"></v-divider>
              </template>
            </v-list-item-group>
          </v-list>
        </v-tab-item>
      </v-tabs-items>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="analyticsDrawer" location="right" width="387" app temporary elevation="2" right class="px-3">
      <v-container class="pb-0 pt-4 px-4 mb-6">
        <div class="d-flex justify-space-between align-center mt-5">
          <div>
            <h3
              class="axi-bold mb-0"
              style="color: #000; font-family: Axiforma; font-size: 36px; font-style: normal; font-weight: 700; line-height: 36px"
            >
              Reporting Analytics
            </h3>
            <!-- <h3 class="text-h6 axi-bold mt-n1">Analytics</h3> -->
          </div>
          <v-btn icon @click="analyticsDrawer = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-container>

      <v-container class="px-4 pb-10" style="overflow-y: auto">
        <v-card outlined class="mb-8 reporting-analytics-card">
          <v-card-text class="mb-3">
            <!-- Encabezado -->
            <div class="d-flex justify-space-between align-center">
              <div class="axi-bold title-cards">Resumen de objetivos</div>
              <v-icon size="16" color="#6366F1">mdi-help-circle-outline</v-icon>
            </div>

            <p
              class="axi-regular mt-n5"
              style="color: #aaa; font-family: Axiforma; font-size: 16px; font-style: normal; font-weight: 400; line-height: 30px"
            >
              Para el período actual
            </p>

            <!-- Scope 1 y 2 -->
            <div class="d-flex justify-space-between align-center mt-4">
              <div class="axi-bold" style="color: #000; font-size: 16px; font-style: normal; line-height: 30px">Scope 1 & 2</div>
              <div class="axi-bold" style="color: #10b981; font-size: 12px">Meta mensual alcanzada</div>
            </div>

            <!-- Scope 3 -->
            <div class="d-flex justify-space-between align-center mt-3">
              <div class="axi-bold" style="color: #000; font-size: 16px; font-style: normal; line-height: 30px">Scope 3</div>
              <v-btn tile outlined small color="#6366F1" class="text-none axi-bold" style="text-transform: none"> Seguimiento absoluto </v-btn>
            </div>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-8 reporting-analytics-card">
          <v-card-text>
            <div class="d-flex justify-space-between align-center mb-4">
              <div class="text-h6 axi-bold reporting-analytics-card-title" style="font-family: 'Axiforma' !important">
                Informar de los progresos
              </div>
              <v-icon size="16" color="#6366F1">mdi-help-circle-outline</v-icon>
            </div>

            <div class="d-flex justify-center mb-3">
              <v-progress-circular :value="30" size="110" width="8" color="#74E3BA">
                <div class="text-center">
                  <div class="text-h6 axi-bold black-bold" style="font-family: 'Axiforma' !important">30%</div>
                  <h5 class="axi-medium" style="color: #aaaaaa; font-family: 'Axiforma' !important">Completado</h5>
                </div>
              </v-progress-circular>
            </div>

            <p class="axi-bold text-center mt-2 black-bold" style="font-family: 'Axiforma' !important">70% pendiente</p>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-8 reporting-analytics-card">
          <v-card-text class="mb-5">
            <div class="d-flex justify-space-between align-center mb-7">
              <div class="text-h6 axi-bold reporting-analytics-card-title" style="font-family: 'Axiforma' !important">
                Plan de acción para el clima
              </div>
              <v-icon size="16" color="#6366F1">mdi-help-circle-outline</v-icon>
            </div>

            <div class="mb-2 d-flex justify-space-between align-center">
              <div class="d-flex align-center">
                <v-icon size="12" color="black" class="mr-2">mdi-menu-right</v-icon>
                <span class="text-body-2 axi-regular black-bold" style="font-family: 'Axiforma' !important">Proyectos desplegados</span>
              </div>
              <strong class="black-bold" style="font-family: 'Axiforma' !important">8</strong>
            </div>

            <div class="mb-2 d-flex justify-space-between align-center">
              <div class="d-flex align-center">
                <v-icon size="12" color="black" class="mr-2">mdi-menu-right</v-icon>
                <span class="text-body-2 axi-regular black-bold" style="font-family: 'Axiforma' !important">Proyectos en curso</span>
              </div>
              <strong class="black-bold" style="font-family: 'Axiforma' !important">5</strong>
            </div>

            <div class="d-flex justify-space-between align-center">
              <div class="d-flex align-center">
                <v-icon size="12" color="black" class="mr-2">mdi-menu-right</v-icon>
                <span class="text-body-2 axi-regular black-bold" style="font-family: 'Axiforma' !important">En tramitación</span>
              </div>
              <strong class="black-bold" style="font-family: 'Axiforma' !important">12</strong>
            </div>
          </v-card-text>
        </v-card>

        <!-- KPIs -->
        <v-card outlined class="mb-8 reporting-analytics-card">
          <v-card-text>
            <div class="d-flex justify-space-between align-center mb-7">
              <div class="text-h6 font-weight-bold reporting-analytics-card-title" style="font-family: 'Axiforma' !important">
                Key environmental KPIs
              </div>
              <v-icon size="16" color="#6366F1">mdi-help-circle-outline</v-icon>
            </div>

            <div class="mb-3 d-flex justify-space-between align-center">
              <span class="text-body-2" style="font-family: 'Axiforma' !important">tCO₂e reduced</span>
              <div class="d-flex align-center">
                <strong class="mr-2 text-body-1 black-bold" style="font-family: 'Axiforma' !important">940</strong>
                <v-icon size="16" color="green">mdi-trending-up</v-icon>
                <span class="text-caption ml-1 text-success" style="font-family: 'Axiforma' !important">15%</span>
              </div>
            </div>

            <div class="mb-3 d-flex justify-space-between align-center">
              <span class="text-body-2" style="font-family: 'Axiforma' !important">MWh saved</span>
              <div class="d-flex align-center">
                <strong class="mr-2 text-body-1 black-bold" style="font-family: 'Axiforma' !important">2,180</strong>
                <v-icon size="16" color="green">mdi-trending-up</v-icon>
                <span class="text-caption ml-1 text-success" style="font-family: 'Axiforma' !important">22%</span>
              </div>
            </div>

            <div class="mb-3 d-flex justify-space-between align-center">
              <span class="text-body-2" style="font-family: 'Axiforma' !important">m³ water saved</span>
              <div class="d-flex align-center">
                <strong class="mr-2 text-body-1 black-bold">15,400</strong>
                <v-icon size="16" color="green">mdi-trending-up</v-icon>
                <span class="text-caption ml-1 text-success" style="font-family: 'Axiforma' !important">8%</span>
              </div>
            </div>

            <div class="d-flex justify-space-between align-center">
              <span class="text-body-2" style="font-family: 'Axiforma' !important">tons recycled</span>
              <div class="d-flex align-center">
                <strong class="mr-2 text-body-1 black-bold" style="font-family: 'Axiforma' !important">340</strong>
                <v-icon size="16" color="green">mdi-trending-up</v-icon>
                <span class="text-caption ml-1 text-success" style="font-family: 'Axiforma' !important">45%</span>
              </div>
            </div>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-4 reporting-analytics-card">
          <v-card-text class="mb-6">
            <!-- Encabezado -->
            <div class="d-flex justify-space-between align-center mb-4">
              <div class="d-flex align-center">
                <v-icon color="orange" size="18" class="mr-2">mdi-bell-outline</v-icon>
                <span class="text-h6 font-weight-bold reporting-analytics-card-title" style="font-family: 'Axiforma' !important">Analogies</span>
              </div>
              <v-icon size="16" color="#6366F1">mdi-help-circle-outline</v-icon>
            </div>

            <!-- Cuerpo -->
            <div class="mb-2">
              <span class="black-bold" style="font-family: 'Axiforma' !important">Equivalent to planting </span>
              <span class="font-weight-bold" style="font-family: 'Axiforma' !important; color: #10b981">42,850</span>
              <span class="black-bold" style="font-family: 'Axiforma' !important"> trees</span>
            </div>

            <div>
              <span class="black-bold" style="font-family: 'Axiforma' !important">Equivalent to recycling </span>
              <span class="font-weight-bold text-green" style="font-family: 'Axiforma' !important; color: #10b981">126</span>
              <span class="black-bold" style="font-family: 'Axiforma' !important"> tons</span>
            </div>
          </v-card-text>
        </v-card>
      </v-container>
    </v-navigation-drawer>

    <!-- <v-main class="background-root"> -->

    <v-main class="background-root no-main-pad">
      <router-view :company="selectedCompany"></router-view>
      <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
        {{ msgSuccess }}
      </v-snackbar>
      <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
        {{ msgError }}
      </v-snackbar>
      <v-dialog v-model="dialogs.update" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Aviso</v-card-title>
          <v-card-text>¿Realmente desea establecer el objetivo de la empresa?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" color="blue-grey" @click="cancelCheck()"> Cancelar </v-btn>
            <v-btn text small :loading="loading" color="success" @click="setObjective()"> Aceptar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-if="no_leidos.length && selectedUnread.length" v-model="dialogs.notificationUnread" persistent max-width="500">
        <v-card>
          <v-card-title class="headline"
            >Notificación
            <v-spacer />
            <v-btn text small :disabled="loading" color="blue-grey" @click="cancelNotification()">
              <v-icon color="red">mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-title>{{ no_leidos[selectedUnread].titulo }}</v-card-title>
          <v-card-text>{{ no_leidos[selectedUnread].fecha }}</v-card-text>
          <v-card-text>{{ no_leidos[selectedUnread].subtitulo }}</v-card-text>
          <!--        <v-card-actions>-->
          <!--          <v-spacer></v-spacer>-->
          <!--          <v-btn text small :disabled="loading" color="blue-grey" @click="cancelNotification()">-->
          <!--            Cancelar-->
          <!--          </v-btn>-->
          <!--          <v-btn text small :loading="loading" color="success" @click="updateNotifications()">-->
          <!--            Marcar como leída-->
          <!--          </v-btn>-->
          <!--        </v-card-actions>-->
        </v-card>
      </v-dialog>
      <v-dialog v-if="leidos.length && selectedRead.length" v-model="dialogs.notificationRead" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">Notificación</v-card-title>
          <v-card-title>{{ leidos[selectedRead].titulo }}</v-card-title>
          <v-card-text>{{ leidos[selectedRead].fecha }}</v-card-text>
          <v-card-text>{{ leidos[selectedRead].subtitulo }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" color="blue-grey" @click="cancelNotification()"> Cancelar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogs.helpHome" max-width="1000px">
        <v-carousel>
          <v-carousel-item v-for="(slide, idx) in sliders.home" :key="idx">
            <v-sheet color="secondary" height="100%" tile>
              <v-row class="fill-height" align="center" justify="center">
                <v-img :src="slide" />
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </v-dialog>
      <v-dialog v-model="dialogs.helpHDC" max-width="1000px">
        <v-carousel>
          <v-carousel-item v-for="(slide, idx) in sliders.hdc" :key="idx">
            <v-sheet color="secondary" height="100%" tile>
              <v-row class="fill-height" align="center" justify="center">
                <v-img :src="slide" />
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </v-dialog>
    </v-main>
    <TourGuide ref="homeGuide" v-on:abrirdrawer="abrirDrawer" v-on:huella-de-carbono="irAHuella" :steps="tourSteps" />
  </v-app>
</template>

<script>
import { mapActions } from 'vuex';
import services from '@/utils/services';
import TourGuide from '@/components/TourGuide.vue';
import { EventBus } from '@/EventBus';

export default {
  name: 'root',
  components: { TourGuide },
  data: () => ({
    monthDialog: false,
    monthMenu: false,
    selectedMonth: new Date().toISOString().substr(0, 7),

    host: process.env.VUE_APP_API_SERVER,
    version: process.env.VUE_APP_VERSION,
    name: process.env.VUE_APP_NAME,
    links: {
      faq: process.env.VUE_APP_LINK_FAQ,
      calendly: process.env.VUE_APP_LINK_CALENDLY
    },
    logo: require('@/assets/logo_home.png'),
    sliders: {
      home: [
        require('@/assets/sliders/home_01.png'),
        require('@/assets/sliders/home_02.png'),
        require('@/assets/sliders/home_03.png'),
        require('@/assets/sliders/home_04.png'),
        require('@/assets/sliders/home_05.png'),
        require('@/assets/sliders/home_06.png')
      ],
      hdc: [
        require('@/assets/sliders/hdc_01.png'),
        require('@/assets/sliders/hdc_02.png'),
        require('@/assets/sliders/hdc_03.png'),
        require('@/assets/sliders/hdc_04.png'),
        require('@/assets/sliders/hdc_05.png'),
        require('@/assets/sliders/hdc_06.png'),
        require('@/assets/sliders/hdc_07.png')
      ]
    },
    path: '/api/logout',
    username: '',
    firstName: '',
    rol: [],
    companies: [],
    selectedCompany: null,
    nameCompany: null,
    loading: false,
    success: false,
    msgSuccess: '',
    error: false,
    msgError: '',
    selectedUnread: [],
    selectedRead: [],
    formularios: [],
    no_leidos: [],
    leidos: [],
    interval: null,
    tab: null,
    objective: null,
    dialogs: {
      update: false,
      notificationUnread: false,
      notificationRead: false,
      helpHome: false,
      helpHDC: false
    },
    objectives: ['Ningún objetivo', 'Cero emisiones en el 2030', 'Cero emisiones en el 2050', 'Reducción anual del 4.2%'],
    drawer: null,
    drawerRight: false,
    items: [
      { icon: 'mdi-home', title: 'Home', path: '/home', public: true, estilo: null },
      { icon: 'mdi-account-circle', title: 'Perfil', path: '/profile', public: true, estilo: null },
      { icon: 'mdi-chart-bar', title: 'Huella de Carbono', path: '/huella-de-carbono', public: false, estilo: 'optionmenu' },
      { icon: 'mdi-chart-pie', title: 'Economía Circular', path: '/economia-circular', public: true, estilo: null },
      { icon: 'mdi-shopping', title: 'Marketplace', path: '/marketplace', public: true, estilo: null },
      { icon: 'mdi-calendar-check', title: 'Responsabilidades', path: '/responsabilidades', public: true, estilo: null }
    ],
    tourSteps: [],
    analyticsDrawer: false,
    companyQuery: '',
    itemsB: [
      { id: 1, name: 'Oficina HQ' },
      { id: 2, name: 'Sucursal B' },
      { id: 3, name: 'Sucursal C' },
      { id: 4, name: 'CEDIS D' }
    ],
    selected: [2],
    tempSelected: [], // <-- que sea array
    displayText: '',
    search: ''
  }),
  mounted() {
    this.checkLocal();
    EventBus.$on('open-drawer', this.abrirDrawer);
    this.check();
    this.searchObjective();
    this.getNotifications();
    this.setIntervalOfNotifications();
    this.tempSelected = [...this.selected];
    this.updateDisplayText();
    this.$nextTick(this.setAppbarVar);
    window.addEventListener('resize', this.setAppbarVar);
    this.setAppbarVar();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setAppbarVar);
  },

  watch: {
    // selectedCompany: function (oldVal, newVal) {
    //   if (newVal && oldVal != newVal) {
    //     this.setCompany({ id: this.selectedCompany });
    //     this.getNameCompany(this.selectedCompany);
    //     this.searchObjective();
    //     this.getForms();
    //   }
    // }
    selectedCompany(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.setCompany({ id: newVal });
        this.getNameCompany(newVal);
        this.searchObjective();
        this.getForms();
        this.$nextTick(this.setAppbarVar);
      }
    }
  },
  computed: {
    displayedCount() {
      const abierto = this.$refs.locationSelect?.isMenuActive;
      return abierto ? this.tempSelected.length : this.selected.length;
    },
    report() {
      return this.$store.state.general.report;
    },
    filteredCompanies() {
      const q = this.companyQuery?.toLowerCase() || '';
      return !q ? this.companies : this.companies.filter((c) => c.nombre.toLowerCase().includes(q));
    },
    formattedMonth() {
      if (!this.selectedMonth) return '';
      const date = new Date(`${this.selectedMonth}-01T00:00:00Z`);
      return date.toLocaleDateString('default', {
        month: 'short',
        year: '2-digit',
        timeZone: 'UTC'
      });
    },
    filteredItems() {
      const s = this.search.trim().toLowerCase();
      if (!s) return this.itemsB;
      return this.itemsB.filter((i) => i.name.toLowerCase().includes(s));
    },
    selectAll: {
      get() {
        if (!this.filteredItems.length) return false;
        return this.filteredItems.every((i) => this.tempSelected.includes(i.id));
      },
      set(val) {
        if (val) {
          const add = this.filteredItems.map((i) => i.id);
          this.tempSelected = Array.from(new Set([...this.tempSelected, ...add]));
        } else {
          const ids = new Set(this.filteredItems.map((i) => i.id));
          this.tempSelected = this.tempSelected.filter((id) => !ids.has(id));
        }
      }
    }
  },
  methods: {
    ...mapActions('general', ['setCompany', 'setReport', 'clearData', 'setExcelReport']),
    //selectedMonth
    onMonthChanged(val) {
      const [year, month] = val.split('-').map(Number);
      // Notifica globalmente

      this.$root.$emit('period-changed', {
        iso: val, // "YYYY-MM"
        year, // 2025
        month // 7
      });
    },
    openLocations() {
      // opcional: por si readonly bloquea el focus
      this.$refs.locationSelect.isMenuActive = true;
    },
    clearLocations() {
      this.tempSelected = [];
      this.updateDisplayText();
    },
    toggle(id) {
      const i = this.tempSelected.indexOf(id);
      console.log('toggle', id, i, this.tempSelected);
      if (i === -1) this.tempSelected.push(id);
      else this.tempSelected.splice(i, 1);
      this.updateDisplayText();
    },
    clearLocations() {
      this.tempSelected = [];
      this.selected = [];
      this.updateDisplayText();
    },
    updateDisplayText() {
      const n = this.tempSelected.length;
      this.displayText = n === 0 ? 'Filtrar por ubicaciones' : n === 1 ? '1 ubicación seleccionada' : `${n} ubicaciones seleccionadas`;
    },
    restoreDisplayText() {
      this.selected = [...this.tempSelected]; // <- commit
      this.$nextTick(this.updateDisplayText);
    },
    onSearchInput(val) {
      // si Vuetify intenta vaciarlo
      if (!this.$refs.locationSelect?.isMenuActive && (val === '' || val == null)) {
        this.updateDisplayText();
      }
    },
    onApply() {
      this.selected = [...this.tempSelected];
      this.$refs.locationSelect.isMenuActive = false;
      this.updateDisplayText();
    },
    onCancel() {
      this.tempSelected = [...this.selected];
      this.$refs.locationSelect.isMenuActive = false;
      this.updateDisplayText();
    },
    getCompanyName(id) {
      const c = this.companies.find((x) => x.id === id);
      return c ? c.nombre : '';
    },
    selectCompany(id) {
      this.selectedCompany = id; // tu watcher ya dispara el resto
    },
    tourGuide(tour) {
      if (!tour.one) {
        this.tourSteps = [
          {
            selector: '.filtrosPanel',
            title: 'Filtro',
            description: 'Escoge la fecha que deseas ver',
            position: 'bottom'
          },
          {
            selector: '.vermenu',
            title: 'Navegación',
            description: '<center>Visualiza el menú</center>',
            position: 'right',
            action: 'drawer'
          },
          {
            selector: '.aotrolugar',
            title: 'Elige una opción:',
            description: '<center>Haz click en "Huella <br> de carbono" para ver los detalles.</center>',
            position: 'bottom',
            action: 'huella-de-carbono'
          }
        ];
        this.$refs.homeGuide.start();
        console.log('Tour uno no lleno');
      } else if (tour.one && tour.two && !tour.three) {
        console.log('Tour uno y dos llenos');
      }
    },
    checkLocal() {
      let tour = JSON.parse(localStorage.getItem('tour'));
      if (!tour) {
        tour = { one: false, two: false, three: false };
        localStorage.setItem('tour', JSON.stringify(tour));
      }

      this.tourGuide(tour);
    },

    // isEconomiaCircularPage() {
    //   // Verifica la ruta actual, adaptando según cómo esté configurado tu router
    //   return this.$route.name === 'economia-circular';
    // },
    openObjectiveSelect() {
      this.$refs.objectiveSelect.focus();
    },

    isValidUrl() {
      const currentUrl = window.location.href;
      return currentUrl.includes('home') || currentUrl.includes('huella-de-carbono');
    },
    abrirDrawer() {
      this.drawer = true;
    },
    irAHuella() {
      let tour = JSON.parse(localStorage.getItem('tour'));

      if (tour) {
        tour.one = true;
        tour.two = false;
        tour.three = false;
      } else {
        tour = { one: true, two: false, three: false };
      }

      localStorage.setItem('tour', JSON.stringify(tour));
      this.$router.push({ path: 'huella-de-carbono' });
    },
    check() {
      this.username = this.$session.get('user');
      this.firstName = this.$session.get('name');
      this.rol = this.$session.get('rol');
      this.companies = this.$session.get('companies');
      this.selectedCompany = this.companies.length ? this.companies[0].id : null;
      this.setCompany({ id: this.selectedCompany });
      this.getNameCompany(this.selectedCompany);
      this.getForms();
    },
    getNameCompany(id) {
      for (let company of this.companies) {
        if (company.id == id) {
          this.nameCompany = ', ' + company.nombre;
        }
      }
    },
    logout() {
      this.loading = true;
      if (this.$session.exists()) {
        this.axios
          .post(this.host + this.path)
          .then((response) => {
            this.clearData();
            this.$session.destroy();
            this.$router.push('/login');
          })
          .catch((error) => {
            this.error = true;
            this.msgError = error.response.data.message;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.$router.push('/login');
      }
    },
    searchObjective() {
      for (let i = 0; i < this.companies.length; i++) {
        if (this.selectedCompany === this.companies[i].id) {
          this.objective = this.companies[i].objetivo ? this.companies[i].objetivo : null;
        }
      }
    },
    objectiveCheck() {
      this.dialogs.update = true;
    },
    cancelCheck() {
      this.dialogs.update = false;
      this.objective = null;
    },
    setObjective() {
      this.loading = true;
      let data = {
        empresa: this.$store.state.general.company,
        objetivo: this.objective
      };
      this.axios
        .put(services.routes.objective, { data })
        .then((response) => {
          this.dialogs.update = false;
        })
        .catch((error) => {
          this.error = true;
          this.msgError = error.response.data.message || 'Servicio no disponible';
        })
        .finally(() => {
          this.loading = false;
        });
    },
    profile() {
      if (this.$route.path !== '/profile') {
        this.$router.push('/profile');
      }
    },
    isPublic() {
      if (this.rol.indexOf('publico') >= 0) {
        return true;
      }
      return false;
    },
    tour() {
      if (this.$route.path === '/home') {
        // this.dialogs.helpHome = true;
        let tour = JSON.parse(localStorage.getItem('tour'));
        tour = { one: false, two: false, three: false, type: 1 };
        localStorage.setItem('tour', JSON.stringify(tour));
        this.tourGuide(tour);
      } else if (this.$route.path === '/huella-de-carbono') {
        //this.dialogs.helpHDC = true;

        let tour = JSON.parse(localStorage.getItem('tour'));

        if (tour) {
          tour.one = true;
          tour.two = false;
          tour.three = false;
          tour.type = 2;
        } else {
          tour = { one: true, two: false, three: false, type: 1 };
        }

        localStorage.setItem('tour', JSON.stringify(tour));
        //window.location = '/huella-de-carbono'
        //this.$router.push({path:'/huella-de-carbono'})
        this.$router.push({ path: '/huella-de-carbono', query: { start: true } });
      }
    },
    getForms() {
      let params = {
        empresa: this.selectedCompany
      };
      this.axios
        .get(services.routes.form, { params })
        .then((response) => {
          this.formularios = response.data.data;
        })
        .catch((error) => {
          this.error = true;
          this.msgError = error.response.data.message || 'Servicio no disponible';
        })
        .finally(() => {});
    },
    getNotifications() {
      this.axios
        .get(services.routes.notifications)
        .then((response) => {
          this.no_leidos = response.data.data.no_leidos.length == 0 ? [] : response.data.data.no_leidos;

          this.leidos = response.data.data.leidos.length == 0 ? [] : response.data.data.leidos;
        })
        .catch((error) => {
          this.error = true;
          this.msgError = error.response.data.message || 'Servicio no disponible';
        })
        .finally(() => {});
    },

    async showNotification(item) {
      this.dialogs.notificationUnread = true;
      console.log('Este es el item', item.id);
      // console.log('no leido', this.no_leidos[this.selectedUnread])
      this.updateNotifications(item.id);
    },
    async updateAllNotifications() {
      this.loading = true;
      let no_leidos_array = [];

      this.no_leidos.forEach((notificacion) => {
        no_leidos_array.push(notificacion.id);
      });

      let data = {
        notificacion: no_leidos_array
      };

      await this.axios
        .put(services.routes.updateAllNotifications, { data })
        .then((response) => {
          this.getNotifications();
          this.cancelNotification();
          this.drawerRight = false;
        })
        .catch((error) => {
          this.error = true;
          this.msgError = error.response.data.message || 'Servicio no disponible';
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async updateNotifications(id) {
      this.loading = true;
      let data = {
        notificacion: id
        //this.no_leidos[this.selectedUnread].id
      };
      await this.axios
        .put(services.routes.updateNotifications, { data })
        .then((response) => {
          this.getNotifications();
        })
        .catch((error) => {
          this.error = true;
          this.msgError = error.response.data.message || 'Servicio no disponible';
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cancelNotification() {
      this.dialogs.notificationUnread = false;
      this.selectedUnread = [];
      this.dialogs.notificationRead = false;
      this.selectedRead = [];
    },
    setAppbarVar() {
      const el = this.$refs.appbar && this.$refs.appbar.$el ? this.$refs.appbar.$el : this.$refs.appbar;
      const h = el ? el.offsetHeight : 0;
      document.documentElement.style.setProperty('--appbar-h', `${h}px`);
    },
    setIntervalOfNotifications() {
      this.interval = setInterval(() => {
        this.getNotifications();
      }, 60000);
    },
    getReportGeneral() {
      this.setReport({ val: true });
    },
    getHomeReportExcel() {
      this.setExcelReport({ val: true });
    }
  }
};
</script>

<style scoped>
/* Oculta el outline interno del v-text-field outlined */
:deep(.outlined-like-button .v-input__slot fieldset) {
  border: 0 !important;
}

/* Quita también las líneas/pseudobordes que pinta Vuetify */
:deep(.outlined-like-button .v-input__slot::before),
:deep(.outlined-like-button .v-input__slot::after) {
  border: 0 !important;
}

/* Si no quieres halo al foco */
:deep(.outlined-like-button.v-input--is-focused .v-input__slot) {
  box-shadow: none !important;
}

.outlined-like-button {
  --h: 32px; /* cambia a 36px si tus botones son más altos */
  height: var(--h);
  min-height: var(--h);
  border: 1px solid rgb(99, 102, 241) !important;
  border-radius: 3px !important;
  background: transparent !important;
  display: flex;
  align-items: center;
  padding: 0; /* que no sume altura */
}

/* el slot interno de Vuetify también debe medir lo mismo */
.outlined-like-button .v-input__control,
.outlined-like-button .v-input__slot {
  height: var(--h) !important;
  min-height: var(--h) !important;
  padding: 0 10px !important; /* horizontal compacto */
}

/* texto y input compactos */
.outlined-like-button .v-select__selections {
  margin: 0 !important;
  line-height: calc(var(--h) - 2px); /* centra el texto */
}
.outlined-like-button input {
  line-height: var(--h) !important;
  height: var(--h) !important;
  padding: 0 !important;
  font-size: 13px; /* opcional: letra un pelín más chica */
}

/* ícono (chevron) centrado y pequeño */
.outlined-like-button .v-input__append-inner,
.outlined-like-button .v-input__prepend-inner {
  margin-top: 0 !important;
  align-self: center;
}
.outlined-like-button .v-icon {
  font-size: 16px !important; /* igual al botón */
  height: 16px;
  width: 16px;
}

.location-menu .actions-footer {
  position: sticky;
  bottom: 0;
  background: #fff;
}
.menu-active {
  border-width: 1px;
  border-radius: 5px;
  border-style: solid;
  border-color: #6366f1 !important;
  background: #eaebff !important;
  color: #6366f1 !important;
  width: 98%;
  font-family: 'Axiforma', sans-serif !important;
  font-weight: 700 !important;
  font-style: Bold !important;
  font-size: 14px !important;
  letter-spacing: 0%;
}

.apply-gradient {
  background: linear-gradient(90deg, #6366f1 0%, #a78bfa 100%);
}
.hotspot-element {
  position: relative;
}
.background-root {
  /*background-color: white !important;*/
  background-color: #f9fafb !important;
}
.app-header {
  z-index: 99;
}
.app-sidemenu {
  z-index: 99;
}
.text-normal {
  text-transform: none !important;
}
.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.4);
}
.text-success {
  color: #16a34a;
}
.v-list-item {
  padding-top: 4px;
  padding-bottom: 4px;
}

.page-boundary {
  max-width: 1280px;
  margin: 0 auto;
  padding-inline: 20px;
}

@media (min-width: 960px) {
  .page-boundary {
    padding-inline: 24px;
  }
}
@media (min-width: 1280px) {
  .page-boundary {
    padding-inline: 3rem;
  }
}

.no-main-pad {
  padding-top: 0 !important;
}

.company-title {
  margin-left: -1rem;
  font-size: clamp(45px, 3.2vw, 48px);
  line-height: 1.1;
  letter-spacing: -0.02em;
}

.company-subtitle {
  color: #aaa !important;
  margin-left: -1rem;
  font-family: 'Axiforma', sans-serif !important;
  font-weight: 400 !important;
  font-size: 1rem !important;
  font-style: normal;
  line-height: 1.875rem;
  letter-spacing: -0.5px !important;
  word-spacing: -1px;
}

.topbar-button {
  border-width: 2px;
  border-radius: 3px;
}

.header-actions {
  gap: 12px;
}

.topbar-buttons-container {
}

.reporting-analytics-card {
  border: 1px solid #a6afff;
  border-radius: 5px;
}

.reporting-analytics-card-title {
  font-weight: 700;
  color: black;
}

.black-bold {
  color: black;
  font-weight: bold;
}

.location-filter .v-input__slot {
  min-height: 30px !important; /* baja la altura */
  padding: 0 12px !important; /* compacta el padding */
}
.location-filter .v-select__selections {
  margin: 0 !important; /* evita empuje vertical */
}
.location-filter .v-input__append-inner {
  margin-top: 4px !important; /* centra la flecha */
}
.selection-text {
  white-space: nowrap; /* una sola línea */
  overflow: hidden;
  text-overflow: ellipsis;
}
.outlined-like-button {
  border: 1 solid rgb(99, 102, 241) !important; /* borde igual que botón */
  border-radius: 3px !important; /* o 4px si no son tile */
  background: transparent !important;
  min-height: 36px !important; /* altura igual a botón */
  display: flex;
  align-items: center;
}

.outlined-like-button .v-input__slot {
  border: none !important; /* quitamos borde interno del slot */
  min-height: 30px !important; /* altura igual a botón */
  padding: 0 12px !important;
}

.outlined-like-button .v-input__append-inner,
.outlined-like-button .v-input__prepend-inner {
  margin-top: 0 !important;
}

.outlined-like-button .v-icon {
  color: #6366f1 !important;
}

.outlined-like-button.v-input.v-input--is-focused {
  box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.12); /* igual que botón focus */
}
.outlined-like-button .v-select__selections {
  margin: 0 !important;
  display: flex;
  align-items: center;
}
.v-btn.v-btn--outlined.v-size--default:not(.v-btn--text) {
  padding-left: 8px !important;
  padding-right: 8px !important;
  min-width: 43px !important; /* igual que alto */
}
.background-root {
  border-top: 10px solid rgba(17, 24, 39, 0.08);
}
.title-cards {
  color: #000;
  font-size: 20px;
  font-style: normal;
  line-height: 61px;
}

/* @media screen and (max-width: 1400px) {
  .company-title {
    font-size: clamp(28px, 3.2vw, 28px);
  }
} */

/* ======= Escalas responsivas 1400→800 sin alterar el DOM ======= */

/* 1200–1399 px */
@media (max-width: 1599.98px) and (min-width: 1200px) {
  /* .page-boundary {
    max-width: 1160px;
    padding-inline: 24px;
  } */

  .company-title {
    margin-left: -0.75rem;
    /* font-size: 44px;  */
    line-height: 1;
  }

  .company-subtitle {
    margin-left: -0.75rem;
    font-size: 0.95rem !important;
    line-height: 1.7rem;
  }

  .header-actions {
    gap: 10px;
  }

  .topbar-button {
    font-size: 16px;
  }

  /* Igualamos alturas de inputs/botones */
  .outlined-like-button {
    --h: 30px;
  }

  .v-btn.v-btn--outlined.v-size--default:not(.v-btn--text) {
    min-width: 40px !important;
  }

  /* Drawer lateral izquierdo (prop width=290) → no tocar DOM */
  .app-sidemenu {
    width: 270px !important;
  }

  /* Drawer de Analytics (prop width=387) */
  .v-navigation-drawer[style*='width: 387px'] {
    width: 360px !important;
  }

  /* Autocomplete de ubicaciones */
  .header-actions .v-autocomplete {
    max-width: 230px !important;
  }
  :deep(.location-menu) {
    max-width: 320px;
  }
  :deep(.location-menu .v-list) {
    max-height: 320px;
  }

  /* AppBar padding más compacto */
  .v-app-bar :deep(.v-container.py-3) {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }

  .title-cards {
    font-size: 18px;
    line-height: 48px;
  }
}

/* 960–1199 px */
@media (max-width: 1199.98px) and (min-width: 960px) {
  .page-boundary {
    max-width: 980px;
    padding-inline: 20px;
  }

  .company-title {
    margin-left: -0.6rem;
    font-size: 42px;
    line-height: 1.1;
  }

  .company-subtitle {
    margin-left: -0.6rem;
    font-size: 0.9rem !important;
    line-height: 1.6rem;
  }

  .header-actions {
    gap: 8px;
  }

  .topbar-button {
    font-size: 12.5px;
  }

  .outlined-like-button {
    --h: 28px;
  }

  .v-btn.v-btn--outlined.v-size--default:not(.v-btn--text) {
    min-width: 38px !important;
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  .app-sidemenu {
    width: 254px !important;
  }
  .v-navigation-drawer[style*='width: 387px'] {
    width: 340px !important;
  }

  .header-actions .v-autocomplete {
    max-width: 210px !important;
  }

  .v-app-bar :deep(.v-container.py-3) {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
  }

  .title-cards {
    font-size: 17px;
    line-height: 40px;
  }
  .reporting-analytics-card {
    border-radius: 4px;
  }
  .reporting-analytics-card-title {
    font-size: 16.5px;
  }
}

/* 800–959 px */
@media (max-width: 959.98px) and (min-width: 800px) {
  .page-boundary {
    max-width: 800px;
    padding-inline: 16px;
  }

  .company-title {
    margin-left: -0.5rem;
    font-size: 32px;
    line-height: 1.08;
  }

  .company-subtitle {
    margin-left: -0.5rem;
    font-size: 0.875rem !important;
    line-height: 1.5rem;
  }

  .header-actions {
    gap: 6px;
  }

  .topbar-button {
    font-size: 12px;
  }

  .outlined-like-button {
    --h: 28px;
  }

  .v-btn.v-btn--outlined.v-size--default:not(.v-btn--text) {
    min-width: 36px !important;
    padding-left: 6px !important;
    padding-right: 6px !important;
  }

  .header-actions .v-autocomplete {
    max-width: 200px !important;
  }

  .app-sidemenu {
    width: 240px !important;
  }
  .v-navigation-drawer[style*='width: 387px'] {
    width: 320px !important;
  }

  .v-app-bar :deep(.v-container.py-3) {
    padding-top: 6px !important;
    padding-bottom: 6px !important;
  }

  .title-cards {
    font-size: 16px;
    line-height: 36px;
  }
  .reporting-analytics-card-title {
    font-size: 16px;
  }

  /* Ajustes de tooltips/menus portaleados */
  :deep(.menu-square) {
    max-width: 320px;
  }
  :deep(.v-menu__content) {
    border-radius: 5px;
  }
}

/* === Mantener todo en una sola fila (sin wrap) y compactar entre 1400→800 px === */

/* 1200–1399 px */
@media (max-width: 1599.98px) and (min-width: 1200px) {
  .header-actions {
    flex-wrap: nowrap !important;
    gap: 8px !important;
  }
  .header-actions > * {
    flex: 0 1 auto;
    min-width: 0;
  }

  /* Botones outlined */
  /* .topbar-button {
    border-width: 1px;
    padding-left: 6px !important;
    padding-right: 6px !important;
    font-size: 12.75px;
  } */

  /* Botón "Abrir analíticas" (es text, no outlined) */
  .header-actions > .v-btn.text-none {
    font-size: 12.75px !important;
    padding-left: 6px !important;
    padding-right: 6px !important;
  }

  /* Iconos más compactos y menos separación del calendario */
  .header-actions .v-btn .v-icon {
    font-size: 16px !important;
  }
  .header-actions .ml-6 {
    margin-left: 6px !important;
  }

  /* Filtro de ubicaciones un poco más angosto */
  .header-actions .v-autocomplete {
    max-width: 220px !important;
  }
  .outlined-like-button .v-input__slot {
    padding: 0 8px !important;
  }
}

/* 960–1199 px */
@media (max-width: 1199.98px) and (min-width: 960px) {
  .header-actions {
    flex-wrap: nowrap !important;
    gap: 6px !important;
  }
  .header-actions > * {
    flex: 0 1 auto;
    min-width: 0;
  }

  .topbar-button {
    border-width: 1px;
    padding-left: 6px !important;
    padding-right: 6px !important;
    font-size: 12px;
  }

  .header-actions > .v-btn.text-none {
    font-size: 12px !important;
    padding-left: 6px !important;
    padding-right: 6px !important;
  }

  .header-actions .v-btn .v-icon {
    font-size: 15px !important;
  }
  .header-actions .ml-6 {
    margin-left: 6px !important;
  }

  .header-actions .v-autocomplete {
    max-width: 190px !important;
  }
  .outlined-like-button .v-input__slot {
    padding: 0 8px !important;
  }

  .page-boundary {
    padding-right: 0px !important;
  }
}

/* 800–959 px */
@media (max-width: 959.98px) and (min-width: 800px) {
  .header-actions {
    flex-wrap: nowrap !important;
    gap: 4px !important;
  }
  .header-actions > * {
    flex: 0 1 auto;
    min-width: 0;
  }

  .topbar-button {
    border-width: 1px;
    padding-left: 4px !important;
    padding-right: 4px !important;
    font-size: 11.5px;
  }

  .header-actions > .v-btn.text-none {
    font-size: 11.5px !important;
    padding-left: 4px !important;
    padding-right: 4px !important;
  }

  .header-actions .v-btn .v-icon {
    font-size: 14px !important;
  }
  .header-actions .ml-6 {
    margin-left: 4px !important;
  }

  .header-actions .v-autocomplete {
    max-width: 180px !important;
  }
  .outlined-like-button {
    --h: 26px;
  }
  .outlined-like-button .v-input__slot {
    padding: 0 6px !important;
  }
}

@media (min-width: 1260px) and (max-width: 1320px) {
  .company-title {
    margin-left: -0.75rem;
    font-size: 54px;
    line-height: 1.1;
  }

  @media screen and (min-width: 1270px) and (max-width: 1282px) and (min-height: 719px) and (max-height: 721px) and (orientation: landscape) {
    .company-title {
      font-size: 44px;
    }
    .header-actions {
      flex-wrap: nowrap !important;
      gap: 4px !important;
    }
    .header-actions > * {
      flex: 0 1 auto;
      min-width: 0;
    }

    .header-actions > .v-btn.text-none {
      font-size: 11.5px !important;
      padding-left: 4px !important;
      padding-right: 4px !important;
    }

    .header-actions .v-btn .v-icon {
      font-size: 14px !important;
    }
    .header-actions .ml-6 {
      margin-left: 4px !important;
    }

    .header-actions .v-autocomplete {
      max-width: 180px !important;
    }
    .outlined-like-button {
      --h: 26px;
    }
    .outlined-like-button .v-input__slot {
      padding: 0 6px !important;
    }

    .page-boundary {
      padding-inline: 1.2rem;
    }
  }
}
</style>
<style>
.location-menu,
.location-menu *:not(.v-icon),
.outlined-like-button,
.outlined-like-button *:not(.v-icon) {
  font-family: 'Axiforma' !important;
}
</style>
